import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

const domains = Object.freeze({
  api: PFLM.BACKEND_DOMAIN,
  'api-front': PFLM.BACKEND_FRONTEND_DOMAIN,
});

@Injectable()
export class BackendInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const newUrl = domains[req.url.split('/')?.[1] ?? ''];

    if (newUrl) {
      const apiReq = req.clone({ ...req, url: `${newUrl}${req.url}`, withCredentials: true });

      return next.handle(apiReq);
    }

    const apiReq = req.clone({ ...req, withCredentials: true });

    return next.handle(apiReq);
  }
}
